import { useState } from 'react';
import { toast } from 'react-toastify';
import { bulkOcrAutoMatchService } from '../../../../services/unassignedReturns.service';
import {
  callUnassigned,
  isWithinBulkLimit,
  MAX_BULK_ASSIGN,
  MAX_BULK_OCR,
  notifyError,
} from './unassignedUtils';

export const useBulkOcr = ({ selectedRows, refreshAll, onAssignedChange, showResult }) => {
  const [bulkRunning, setBulkRunning] = useState(false);

  const handleBulkOcr = async () => {
    if (bulkRunning || !isWithinBulkLimit(selectedRows.length, MAX_BULK_OCR, 'Run OCR & Auto-Match')) return;
    setBulkRunning(true);
    const { ok, body, message } = await callUnassigned(
      () => bulkOcrAutoMatchService(selectedRows.map((r) => r.PackageId)),
      'Bulk OCR failed'
    );
    setBulkRunning(false);
    const entity = body?.Entity;
    if (!ok || !entity) {
      notifyError(ok ? 'Bulk OCR failed' : message);
      return;
    }
    toast.success(
      `OCR run on ${entity.totalRequested}: ${entity.assignedCount} auto-assigned, ${entity.remainingUnassignedCount} still unassigned.`
    );
    showResult({ title: 'Run OCR & Auto-Match', result: entity });
    refreshAll();
    if (entity.assignedCount > 0) onAssignedChange();
  };

  return { bulkRunning, handleBulkOcr };
};

export const useManualAssign = ({ selectedRows, refreshAll, onAssignedChange, showResult }) => {
  const [assignRows, setAssignRows] = useState([]);

  const openBulkAssign = () => {
    if (isWithinBulkLimit(selectedRows.length, MAX_BULK_ASSIGN, 'Bulk Assign')) setAssignRows(selectedRows);
  };

  const closeAssign = () => setAssignRows([]);

  const handleAssignDone = ({ bulk, result, refreshOnly }) => {
    setAssignRows([]);
    refreshAll();
    if (refreshOnly) return;
    onAssignedChange();
    if (bulk && result) {
      toast.success(`${result.assignedCount} of ${result.totalRequested} assigned, ${result.remainingUnassignedCount} still unassigned.`);
      showResult({ title: 'Bulk Assign Manually', result });
    }
  };

  return { assignRows, setAssignRows, openBulkAssign, closeAssign, handleAssignDone };
};
